import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { BrowseProgramPage } from "@features/program/BrowseProgramPage"
import { FilmSearchMode } from "@features/program/useFilmSearch"
import { useProgramBackButton } from "@features/program/useProgramBackButton"
import { useProgramModes } from "@features/program/useProgramModes"
import { useRoute } from "eddev/routing"
import { defineView } from "eddev/views"
import { useEffect, useMemo } from "react"

export const meta: ViewMeta = {
  templateName: "Program Page",
}

export default defineView("program", (props) => {
  const route = useRoute()
  const modes = useProgramModes()

  const browseMode = useMemo((): FilmSearchMode => {
    // Detect the current browse mode from the URL
    for (let [key, def] of modes.entries()) {
      if (route.pathname.toLowerCase().includes("/" + key)) {
        return key as FilmSearchMode
      }
    }
    // If no mode is found, default to the first available mode
    if (modes.has("featured")) {
      return "featured"
    } else {
      return [...modes.keys()][0] ?? "a-z"
    }
  }, [route])

  return (
    <>
      <BrowseProgramPage mode={browseMode}>
        <SubpageContentBlocks blocks={props.page?.contentBlocks!} />
      </BrowseProgramPage>
      <div className="h-10" />
    </>
  )
})
